declare namespace $ {

	type $mol_view__dom_name_shm_hitalama_card_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_hitalama_card_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_shm_hitalama_card_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_hitalama_card_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_card_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_card['content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_card extends $mol_view {
		Title( ): $mol_view
		Head( ): $mol_view
		Body( ): $mol_view
		dom_name( ): string
		title( ): string
		content( ): readonly($mol_view_content)[]
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map